import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer-wrapper section-bg2",
  "data-background": "assets/img/gallery/footer_bg.png"
}
const _hoisted_2 = { class: "footer-area footer-padding" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row d-flex justify-content-between" }
const _hoisted_5 = { class: "col-xl-3 col-lg-3 col-md-4 col-sm-6" }
const _hoisted_6 = { class: "single-footer-caption mb-50" }
const _hoisted_7 = { class: "single-footer-caption mb-30" }
const _hoisted_8 = { class: "footer-tittle" }
const _hoisted_9 = { class: "footer-logo mb-20" }
const _hoisted_10 = { class: "col-xl-3 col-lg-3 col-md-4 col-sm-5" }
const _hoisted_11 = { class: "single-footer-caption mb-50" }
const _hoisted_12 = { class: "footer-tittle" }
const _hoisted_13 = { class: "footer-bottom-area" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "footer-border" }
const _hoisted_16 = { class: "row d-flex justify-content-between align-items-center" }
const _hoisted_17 = { class: "col-xl-10 col-lg-9" }
const _hoisted_18 = { class: "footer-copy-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_router_link, { to: "/" }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logo/logonew.png",
                            alt: "Global Holy Ministries"
                          }, null, -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"col-xl-3 col-lg-3 col-md-4 col-sm-5\" data-v-2a553428><div class=\"single-footer-caption mb-50\" data-v-2a553428><div class=\"footer-tittle\" data-v-2a553428><h4 data-v-2a553428>Contact Info</h4><ul data-v-2a553428><li data-v-2a553428><p data-v-2a553428>Address: 3100 Gilmore Trace, Lexington, KY 40511</p></li><li data-v-2a553428><a href=\"tel:+18594569774\" data-v-2a553428>Phone: +18594569774</a></li><li data-v-2a553428><a href=\"mailto:globalholyministries@gmail.com\" data-v-2a553428>Email: globalholyministries@gmail.com</a></li></ul></div></div></div>", 1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Important Links", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: "/" }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("Home", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: "/about" }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("About Us", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: "/events" }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("Events", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: "/contact" }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("Contact Us", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-xl-3 col-lg-3 col-md-4 col-sm-5" }, [
              _createElementVNode("div", { class: "single-footer-caption mb-50" }, [
                _createElementVNode("div", { class: "footer-tittle" }, [
                  _createElementVNode("h4", null, "Newsletter"),
                  _createElementVNode("div", { class: "footer-pera footer-pera2" }, [
                    _createElementVNode("p", null, "Stay updated with our latest events and ministry news.")
                  ]),
                  _createElementVNode("div", { class: "footer-form" }, [
                    _createElementVNode("div", { id: "mc_embed_signup" }, [
                      _createElementVNode("form", {
                        target: "_blank",
                        action: "#",
                        method: "get",
                        class: "subscribe_form relative mail_part"
                      }, [
                        _createElementVNode("input", {
                          type: "email",
                          name: "email",
                          id: "newsletter-form-email",
                          placeholder: "Email Address",
                          class: "placeholder hide-on-focus",
                          onfocus: "this.placeholder = ''",
                          onblur: "this.placeholder = ' Email Address '"
                        }),
                        _createElementVNode("div", { class: "form-icon" }, [
                          _createElementVNode("button", {
                            type: "submit",
                            name: "submit",
                            id: "newsletter-submit",
                            class: "email_icon newsletter-submit button-contactForm"
                          }, [
                            _createElementVNode("img", {
                              src: "assets/img/gallery/form.png",
                              alt: ""
                            })
                          ])
                        ]),
                        _createElementVNode("div", { class: "mt-10 info" })
                      ])
                    ])
                  ])
                ])
              ])
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("p", null, [
                      _createTextVNode("Copyright ©" + _toDisplayString(_ctx.currentYear) + " Global Holy Ministries. All rights reserved | Made with ", 1),
                      _cache[8] || (_cache[8] = _createElementVNode("i", {
                        class: "fa fa-heart",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _cache[9] || (_cache[9] = _createTextVNode(" for God's Glory", -1))
                    ])
                  ])
                ]),
                _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"col-xl-2 col-lg-3\" data-v-2a553428><div class=\"footer-social f-right\" data-v-2a553428><a href=\"#\" data-v-2a553428><i class=\"fab fa-twitter\" data-v-2a553428></i></a><a href=\"#\" data-v-2a553428><i class=\"fab fa-facebook-f\" data-v-2a553428></i></a><a href=\"#\" data-v-2a553428><i class=\"fab fa-youtube\" data-v-2a553428></i></a><a href=\"#\" data-v-2a553428><i class=\"fab fa-instagram\" data-v-2a553428></i></a></div></div>", 1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { id: "back-top" }, [
      _createElementVNode("a", {
        title: "Go to Top",
        href: "#"
      }, [
        _createElementVNode("i", { class: "fas fa-level-up-alt" })
      ])
    ], -1))
  ]))
}